<template>
  <form
    ref="formRequestToken"
    class="form__request-token"
    novalidate
    @submit.prevent="submitForm"
  >
    <v-layout wrap>
      <v-flex sm6 xs12>
        <div class="pr-2--desktop">
          <FormTextField
            v-model="requestTokenForm.name"
            :label="$t(`${namespace}.nameInput`)"
            :placeholder="$t(`${namespace}.emailPlaceholder`)"
            :disabled="submitted"
            :name="$t(`${namespace}.nameName`)"
            :v-validate="{ required: true }"
          />
        </div>
      </v-flex>

      <v-flex sm6 xs12>
        <div class="pl-2--desktop">
          <FormTextField
            v-model="requestTokenForm.email"
            type="email"
            :label="$t(`${namespace}.emailInput`)"
            :placeholder="$t(`${namespace}.emailPlaceholder`)"
            :disabled="submitted"
            :name="$t(`${namespace}.emailName`)"
            :v-validate="{ required: true, email: true }"
          />
        </div>
      </v-flex>

      <v-flex xs12>
        <FormTextarea
          v-model="requestTokenForm.justification"
          :label="$t(`${namespace}.justificationInput`)"
          :placeholder="$t(`${namespace}.justificationPlaceholder`)"
          :disabled="submitted"
          :name="$t(`${namespace}.justificationName`)"
          counter
          maxlength="500"
          :v-validate="{ required: true, max: 500 }"
        />
      </v-flex>

      <v-flex xs12 class="page__button">
        <Button
          type="submit"
          :disabled="submitted"
          :loading="submitted"
        >
          {{ $t(`${namespace}.btnRequest`) }}
        </Button>
      </v-flex>
    </v-layout>
  </form>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { catchError } from 'corp-front-vue-commons/src/utils/functions'

export default {
  name: 'Form',
  data () {
    return {
      namespace: 'Views.RequestTokenPage',
      requestTokenForm: {
        name: '',
        email: '',
        justification: ''
      },
      submitted: false
    }
  },
  computed: {
    ...mapState({
      company: state => state.company.selectedCompany
    })
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    async submitForm () {
      const isValid = await this.$validator.validateAll()

      if (!isValid) return

      try {
        const data = this.requestTokenForm
        const companyId = this.company ? this.company.id : null

        if (!companyId) {
          this.showAlert({
            type: 'info',
            message: this.$t(`${this.namespace}.noCompanySelected`)
          })

          return
        }
        this.submitted = true

        await this.$apiService.requestApiToken.create(companyId, data)

        setTimeout(() => {
          this.submitted = false
          this.resetForm()
          this.$emit('submittedForm')
          this.showAlert({
            type: 'success',
            message: this.$t(`${this.namespace}.requestSuccess`)
          })
        }, 3000)
      } catch (error) {
        this.submitted = false
        this.showAlert({
          type: 'error',
          message: this.$t(`${this.namespace}.requestError`)
        })
        catchError(error)
      }
    },

    resetForm () {
      this.requestTokenForm = {
        name: '',
        email: '',
        justification: ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.form__request-token {
  padding: 8px;
}

.page__button {
  display: flex;
  justify-content: flex-end;
}
</style>
